import React from "react";
import { Breadcrumb } from "element-react";
import { useArticleReviewTracker } from "./use-atricle-review-tracker";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import "./article-review-tracker.css";
import { UserDetailInterface } from "interfaces/actions/auth";
import { isEmpty, renderStatus } from "helpers";

const ArticleReviewTracker = (props) => {
  const { data } = useArticleReviewTracker(props);
  const { RoleName } = useSelector(
    (state: any) => state.userReducer.loggedInUserDetail as UserDetailInterface
  );

  if (!data) return <></>;
  const { Article, CoAuthors, StatusLogs } = data;
  return (
    <>
      <Breadcrumb separator="/">
        <Breadcrumb.Item>
          <Link to="/">Home</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>View</Breadcrumb.Item>
      </Breadcrumb>
      <div className="article-review-tracker">
        <div className="article-meta">
          <div className="meta-item">
            <div className="meta-label">Article Title</div>
            <div className="meta-value">{Article?.ProposalTitle}</div>
          </div>
          <div className="meta-item">
            <div className="meta-label">Submission Number</div>
            <div className="meta-value">{Article?.SubmissionNumber}</div>
          </div>
          <div className="meta-item">
            <div className="meta-label">Author</div>
            <div className="meta-value">{`${
              Article?.InvestigatorSalutation ?? ""
            } ${Article?.InvestigatorName}`}</div>
          </div>
          {CoAuthors?.map((coAuthor, index) => (
            <div className="meta-item" key={index}>
              <div className="meta-label">Co-author</div>
              <div className="meta-value">{`${coAuthor.Salutation ?? ""} ${
                coAuthor.FullName
              }`}</div>
            </div>
          ))}

          <div className="meta-item">
            <div className="meta-label">Current Status</div>
            <div className="meta-value" style={{ display: "flex" }}>
              {renderStatus(
                { ReviewStatus: "" },
                RoleName,
                Article.Status,
                "",
                0
              )}
            </div>
          </div>
        </div>

        <div className="timeline-container">
          <div className="timeline">
            {StatusLogs.map((step, idx) => (
              <div key={idx} className="review-step">
                <div className="step-marker">{idx + 1}</div>

                <div className="step-content">
                  <div className="step-title">{step.StatusInfo}</div>
                  <div className="step-details">{step.StatusOn}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ArticleReviewTracker;
